import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import CogsIcon from '../../../Icons/CogsIcon/CogsIcon';
import AdminMenu from '../../../Management/ContentManagement/AdminMenu';

import './ModerationAdmin.scss';

const ModerationAdmin = ({ hash, title, type }) => {
    const [showAdminMenu, setShowAdminMenu] = useState(false);
    const [cmsLink, setCmsLink] = useState('');
    const [adminMenu, setAdminMenu] = useState([]);

    const toggleAdminMenu = useCallback(async () => {
        if (!showAdminMenu) {
            const res = await axios.get(
                `/api/content-management/admin-menu/${type}/${hash}`
            );
            setAdminMenu(res.data?.actions);
            setCmsLink(res.data?.cmsLink);
            setShowAdminMenu(!showAdminMenu);
        }
    }, [showAdminMenu, type, hash]);

    const closeAdminMenu = useCallback(() => setShowAdminMenu(false), [
        setShowAdminMenu,
    ]);

    return (
        <div
            className="component-ModerationAdmin"
            onClick={toggleAdminMenu}
            onKeyPress={toggleAdminMenu}
            role="button"
            tabIndex={0}
        >
            <CogsIcon />
            <span className="moderationAdmin-label">Admin tools</span>
            {showAdminMenu && type !== 'jobbing' && (
                <AdminMenu
                    hash={hash}
                    type={type}
                    contentTitle={title}
                    adminMenu={adminMenu}
                    cmsLink={cmsLink}
                    openAdminMenu={showAdminMenu}
                    closeAdminMenu={closeAdminMenu}
                    toggleAdminMenu={toggleAdminMenu}
                    showMenuIcon={false}
                />
            )}
        </div>
    );
};

ModerationAdmin.propTypes = {
    hash: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
};
ModerationAdmin.defaultProps = {};

ModerationAdmin.displayName = 'ModerationAdmin';

export default ModerationAdmin;
